import { Injectable } from '@angular/core';

import { LocalStorageService } from '@services/local-storage.service';
import { UserRoleEnum } from '@enums/user-role.enum';

/**
 * role manager helper
 */
@Injectable({
  providedIn: 'root'
})
export class RoleManagerHelper {

  constructor(private localStorageService: LocalStorageService) {}

  /**
   * check is customer admin role
   */
  isCustomerAdminRole(): boolean {
    return this.localStorageService.getCurrentUserRole() === UserRoleEnum.CUSTOMER_ADMIN;
  }

  /**
   * check is customer role
   */
  isCustomerRole(): boolean {
    return this.localStorageService.getCurrentUserRole() === UserRoleEnum.CUSTOMER_COORDINATOR
      || this.localStorageService.getCurrentUserRole() === UserRoleEnum.CUSTOMER_ADMIN;
  }

  /**
   * check is vendor role
   */
  isVendorRole(): boolean {
    return this.localStorageService.getCurrentUserRole() === UserRoleEnum.VENDOR_COORDINATOR
      || this.localStorageService.getCurrentUserRole() === UserRoleEnum.VENDOR_ADMIN
      || this.localStorageService.getCurrentUserRole() === UserRoleEnum.VENDOR_DRIVER;
  }

  /**
   * check is customer / vendor role
   */
  isCustomerVendorRole(): boolean {
    return this.isCustomerRole() || this.isVendorRole();
  }

}
